document.documentElement.classList.add('js');

/* Self-contained so the block behaves the same on all four concepts, including
   the one with no reveal observer of its own. Written to survive the Shopify
   build, which strips scripts out of the body and concatenates them into one
   asset file — so no document.currentScript, and no assumption about when it
   runs relative to the markup. */
(function(){
  document.documentElement.classList.add('ch-js');
  function start(){
    var els = [].slice.call(document.querySelectorAll('.ch'));
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:0.15});
    els.forEach(function(el){ io.observe(el); });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

(function(){
  var $  = function(s,r){return (r||document).querySelector(s);};
  var $$ = function(s,r){return [].slice.call((r||document).querySelectorAll(s));};
  var nav=$('#nav');
  if(nav){var on=function(){nav.classList.toggle('stuck',scrollY>30);};
    addEventListener('scroll',on,{passive:true});document.addEventListener('scroll',on,{passive:true});on();}
  var form=$('#enquiry');
  if(form){form.addEventListener('submit',function(e){
    e.preventDefault();
    $$('.err',form).forEach(function(n){n.remove();});
    var bad=$$('[required]',form).filter(function(f){return !f.value.trim();});
    if(bad.length){bad.forEach(function(f){var m=document.createElement('div');
      m.className='err';m.style.cssText='color:var(--yellow);font-size:13.5px;font-weight:700;margin-top:6px';
      m.textContent='We need this one';f.parentNode.appendChild(m);});bad[0].focus();return;}
    var n=$('.formnote',form); if(n){n.textContent='Got it — we’ll be back within one working day.';}
    form.reset();});}
})();
